import type {
    SupplierClusterMemberMatchBasis,
    SupplierContactType,
    SupplierEntityType,
} from "~/pages/supplier-360/types/Supplier360Types";

export const SUPPLIER_ENTITY_TYPE_LABEL: Record<SupplierEntityType, string> = {
    company: 'Company',
    brand: 'Brand',
};

export const SUPPLIER_MATCH_BASIS_LABEL: Record<SupplierClusterMemberMatchBasis, string> = {
    vat: 'VAT match',
    fuzzy_name: 'Fuzzy name',
    llm_confirmed: 'LLM confirmed',
    manual: 'Manual',
};

export const SUPPLIER_CONTACT_TYPE_LABEL: Record<SupplierContactType, string> = {
    relation_manager: 'Relation managers',
    internal_stakeholder: 'Internal stakeholders',
};

/** One person of each type, for display (e.g. "No {singular} yet"). */
export const SUPPLIER_CONTACT_TYPE_SINGULAR: Record<SupplierContactType, string> = {
    relation_manager: 'relation manager',
    internal_stakeholder: 'internal stakeholder',
};

/** The design's own per-field `searchPlaceholder`. */
export const SUPPLIER_CONTACT_SEARCH_PLACEHOLDER: Record<SupplierContactType, string> = {
    relation_manager: 'Search a name',
    internal_stakeholder: 'Search a name',
};
